import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function fieldMatchValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const { password, passwordConfirm } = control.value;

  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return { fieldMatch: true };
}
